export default __webpack_public_path__ + "images/notes-image.29bd9bc9e23c7686ade19a167c316eea.png";